export default __webpack_public_path__ + "static/media/hht1_ep15_timeline_q04_b.5961092b.png";